import { useEffect, useState } from 'react';
import { prestamoService } from '../../services/api';
import '../../styles/Reportes.css';

const PrestamosRutas = () => {
  const [prestamos, setPrestamos] = useState([]);
  const [porRuta, setPorRuta] = useState({});
  const [cargando, setCargando] = useState(false);
  const [rutaSeleccionada, setRutaSeleccionada] = useState('');

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const response = await prestamoService.getAll();
      const todosPrestamos = response.data.prestamos || [];

      // Agrupar por ruta
      const agrupados = todosPrestamos.reduce((acc, p) => {
        const rutaKey = p.ruta_id || 'sin_ruta';
        const rutaNombre = p.ruta_id ? `Ruta ${p.ruta_id}` : 'Sin Ruta Asignada';

        if (!acc[rutaKey]) {
          acc[rutaKey] = {
            nombre: rutaNombre,
            prestamos: [],
            totalPrestado: 0,
            totalAPagar: 0,
            activos: 0,
            pagados: 0,
            atrasados: 0,
            vencidos: 0
          };
        }

        acc[rutaKey].prestamos.push(p);
        acc[rutaKey].totalPrestado += p.monto_prestado;
        acc[rutaKey].totalAPagar += p.total;

        if (p.estado === 'activo') acc[rutaKey].activos++;
        else if (p.estado === 'pagado') acc[rutaKey].pagados++;
        else if (p.estado === 'atrasado') acc[rutaKey].atrasados++;
        else if (p.estado === 'vencido') acc[rutaKey].vencidos++;

        return acc;
      }, {});

      setPorRuta(agrupados);
      setPrestamos(todosPrestamos);
    } catch (error) {
      alert('Error al cargar préstamos');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO');
  };

  const prestamosFiltrados = rutaSeleccionada
    ? porRuta[rutaSeleccionada]?.prestamos || []
    : [];

  const calcularTotales = () => {
    const totales = Object.values(porRuta).reduce((acc, ruta) => ({
      totalPrestado: acc.totalPrestado + ruta.totalPrestado,
      totalAPagar: acc.totalAPagar + ruta.totalAPagar,
      activos: acc.activos + ruta.activos,
      pagados: acc.pagados + ruta.pagados,
      atrasados: acc.atrasados + ruta.atrasados,
      vencidos: acc.vencidos + ruta.vencidos
    }), {
      totalPrestado: 0,
      totalAPagar: 0,
      activos: 0,
      pagados: 0,
      atrasados: 0,
      vencidos: 0
    });

    return totales;
  };

  const totales = calcularTotales();

  return (
    <div className="reporte-detalle">
      <div className="reporte-header">
        <h1>�️ Préstamos por Rutas</h1>
        <p>Distribución geográfica de la cartera de préstamos</p>
      </div>

      {cargando && (
        <div className="loading">Cargando distribución por rutas...</div>
      )}

      {!cargando && Object.keys(porRuta).length > 0 && (
        <>
          <div className="resumen-cards">
            <div className="card-resumen">
              <div className="card-icono">🗺️</div>
              <div className="card-info">
                <div className="card-valor">{Object.keys(porRuta).length}</div>
                <div className="card-label">Rutas Activas</div>
              </div>
            </div>

            <div className="card-resumen">
              <div className="card-icono">💰</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalPrestado.toFixed(2)}</div>
                <div className="card-label">Total Prestado</div>
              </div>
            </div>

            <div className="card-resumen">
              <div className="card-icono">💵</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalAPagar.toFixed(2)}</div>
                <div className="card-label">Total a Recaudar</div>
              </div>
            </div>

            <div className="card-resumen">
              <div className="card-icono">📊</div>
              <div className="card-info">
                <div className="card-valor">{prestamos.length}</div>
                <div className="card-label">Total Préstamos</div>
              </div>
            </div>
          </div>

          <div className="info-prestamo" style={{ marginTop: '30px' }}>
            <h3>📊 Resumen por Estado</h3>
            <div className="info-grid">
              <div>
                <strong>✅ Pagados:</strong> {totales.pagados}
              </div>
              <div>
                <strong>⏳ Activos:</strong> {totales.activos}
              </div>
              <div>
                <strong>⚠️ Atrasados:</strong> {totales.atrasados}
              </div>
              <div>
                <strong>🚨 Vencidos:</strong> {totales.vencidos}
              </div>
            </div>
          </div>

          <div className="info-prestamo" style={{ marginTop: '30px' }}>
            <h3>🗺️ Distribución por Rutas</h3>
            <div className="tabla-container">
              <table className="tabla-reporte">
                <thead>
                  <tr>
                    <th>Ruta</th>
                    <th>Cantidad</th>
                    <th>Total Prestado</th>
                    <th>Total a Pagar</th>
                    <th>Activos</th>
                    <th>Pagados</th>
                    <th>Atrasados</th>
                    <th>Vencidos</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(porRuta).map(([key, ruta]) => (
                    <tr key={key}>
                      <td><strong>{ruta.nombre}</strong></td>
                      <td>{ruta.prestamos.length}</td>
                      <td>${ruta.totalPrestado.toFixed(2)}</td>
                      <td>${ruta.totalAPagar.toFixed(2)}</td>
                      <td>
                        <span className="badge badge-activo">{ruta.activos}</span>
                      </td>
                      <td>
                        <span className="badge badge-pagado">{ruta.pagados}</span>
                      </td>
                      <td>
                        <span className="badge badge-atrasado">{ruta.atrasados}</span>
                      </td>
                      <td>
                        <span className="badge badge-vencido">{ruta.vencidos}</span>
                      </td>
                      <td>
                        <button
                          onClick={() => setRutaSeleccionada(key)}
                          className="btn-buscar"
                          style={{ padding: '5px 10px', fontSize: '0.9em' }}
                        >
                          Ver Detalle
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="totales">
                    <td><strong>TOTALES</strong></td>
                    <td><strong>{prestamos.length}</strong></td>
                    <td><strong>${totales.totalPrestado.toFixed(2)}</strong></td>
                    <td><strong>${totales.totalAPagar.toFixed(2)}</strong></td>
                    <td><strong>{totales.activos}</strong></td>
                    <td><strong>{totales.pagados}</strong></td>
                    <td><strong>{totales.atrasados}</strong></td>
                    <td><strong>{totales.vencidos}</strong></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {rutaSeleccionada && (
            <div className="info-prestamo" style={{ marginTop: '30px', background: '#f8f9fa' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>� Detalle de {porRuta[rutaSeleccionada].nombre}</h3>
                <button
                  onClick={() => setRutaSeleccionada('')}
                  className="btn-buscar"
                  style={{ background: '#6c757d' }}
                >
                  Cerrar
                </button>
              </div>

              <div className="tabla-container" style={{ marginTop: '15px' }}>
                <table className="tabla-reporte">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Cliente ID</th>
                      <th>Fecha</th>
                      <th>Monto</th>
                      <th>Total</th>
                      <th>Modalidad</th>
                      <th>Cuotas</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prestamosFiltrados.map(prestamo => (
                      <tr key={prestamo.id}>
                        <td>{prestamo.id}</td>
                        <td>{prestamo.cliente_id}</td>
                        <td>{formatearFecha(prestamo.fecha_inicio)}</td>
                        <td>${prestamo.monto_prestado.toFixed(2)}</td>
                        <td>${prestamo.total.toFixed(2)}</td>
                        <td>{prestamo.modalidad}</td>
                        <td>{prestamo.cuotas_pagadas}/{prestamo.cuotas}</td>
                        <td>
                          <span className={`badge badge-${prestamo.estado}`}>
                            {prestamo.estado}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="info-prestamo" style={{ marginTop: '20px', background: '#e8f5e9' }}>
            <h3 style={{ color: '#2e7d32' }}>💡 Análisis de Rutas</h3>
            <ul style={{ lineHeight: '1.8', color: '#388e3c' }}>
              <li>
                <strong>Ruta más productiva:</strong> {
                  Object.entries(porRuta).reduce((max, [key, ruta]) =>
                    ruta.totalPrestado > max.total ? { nombre: ruta.nombre, total: ruta.totalPrestado } : max
                  , { nombre: '', total: 0 }).nombre
                } con ${
                  Object.entries(porRuta).reduce((max, [key, ruta]) =>
                    ruta.totalPrestado > max ? ruta.totalPrestado : max
                  , 0).toFixed(2)
                } prestados
              </li>
              <li>
                <strong>Ruta con más préstamos:</strong> {
                  Object.entries(porRuta).reduce((max, [key, ruta]) =>
                    ruta.prestamos.length > max.cantidad ? { nombre: ruta.nombre, cantidad: ruta.prestamos.length } : max
                  , { nombre: '', cantidad: 0 }).nombre
                } con {
                  Object.entries(porRuta).reduce((max, [key, ruta]) =>
                    ruta.prestamos.length > max ? ruta.prestamos.length : max
                  , 0)
                } préstamos
              </li>
              <li>
                <strong>Promedio por ruta:</strong> {(prestamos.length / Object.keys(porRuta).length).toFixed(1)} préstamos
              </li>
            </ul>
          </div>
        </>
      )}

      {!cargando && Object.keys(porRuta).length === 0 && (
        <div className="sin-datos">
          <p>No hay préstamos registrados</p>
        </div>
      )}
    </div>
  );
};

export default PrestamosRutas;
